import _ from "underscore"
import ParametersFormatter from "../../../parametersFormatting/ParametersFormatter"
import BaseParametersFormattingStrategy from "../../../parametersFormatting/BaseParametersFormattingStrategy"
import messageResource from "../../../messageResource"
import DateRangeFormattingStrategy from '../../../parametersFormatting/DateRangeFormattingStrategy'

const ParametersFormattingStrategy = function() {};

ParametersFormattingStrategy.prototype = _.create(BaseParametersFormattingStrategy.prototype, {

    init: function ({selectorsData, dateFormat, productSettingsValidator, reportRightsValidator, reportAuthorizationInfo, reportParamsStringBuilderConstructor}) {
        BaseParametersFormattingStrategy.prototype.init.call(this, {selectorsData, dateFormat, reportAuthorizationInfo, reportParamsStringBuilderConstructor})
        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;
        this.assignedInfo = selectorsData.assignedInfo;

        return this;
    },

    createParametersFormatter: function({selectorsData, dateFormat, reportAuthorizationInfo, reportParamsStringBuilderConstructor}) {
        return new ParametersFormatter().init({
            selectorsData: selectorsData,
            dateFormat: dateFormat,
            ugrFeatureEnabled: selectorsData.userGroupsEnabled,
            tzgFeatureEnabled: selectorsData.timeZoneGroupsEnabled,
            reportAuthorizationInfo: reportAuthorizationInfo,
            reportParamsStringBuilderConstructor: reportParamsStringBuilderConstructor,
        })
    },

    createDateParametersFormattingStrategy: function(config) {
        return new DateRangeFormattingStrategy(config.dateFormat)
    },

    formatMainPartOfLightboxTitle: function(selectedParameters)
    {
        var enabledPTO =  this.productSettingsValidator.isPTOEnabled();
        var enabledSick =  this.productSettingsValidator.isSickEnabled();

        var reportTypeText = "";
        if (!this.reportRightsValidator.isCanViewBalances() || (!enabledPTO && !enabledSick))
        {
            reportTypeText = messageResource.getMessage('leave_and_balances_report.title.leave_time');    
        }    
        else
        {
            var balanceMessage = "";
            
            if (enabledPTO && enabledSick)
                balanceMessage = messageResource.getMessage("leave_and_balances_report.title.balances");
            else if (enabledPTO)
                balanceMessage = messageResource.getMessage("leave_and_balances_report.title.pto");
            else if (enabledSick)
                balanceMessage = messageResource.getMessage("leave_and_balances_report.title.sick");

            reportTypeText = messageResource.getMessage('leave_and_balances_report.title.leave_time_and_balances', [balanceMessage]);
        }
        
        var dateParameters = this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters);
        var grouping = LeavesReportFormatUtils.formatGroupingLevel(selectedParameters.firstGroupingLevel);
        return messageResource.getMessage("leave_and_balances_report.title", [reportTypeText, grouping, dateParameters]);
    },

    formatParametersText: function(selectedParameters)
    {
        return this.parametersFormatter.formatUsersSelection(selectedParameters.userSelection, this.assignedInfo) + "; " +
               this.parametersFormatter.formatLeaveTypesSelection(selectedParameters.leaveTypeSelection);
    }
});

export default ParametersFormattingStrategy


// WEBPACK FOOTER //
// ./web/js/reports/leavesReport/pdfPreview/ParametersFormattingStrategy.js